var l = (o, s, t) => new Promise((d, i) => {
  var f = (a) => {
    try {
      r(t.next(a));
    } catch (e) {
      i(e);
    }
  }, n = (a) => {
    try {
      r(t.throw(a));
    } catch (e) {
      i(e);
    }
  }, r = (a) => a.done ? d(a.value) : Promise.resolve(a.value).then(f, n);
  r((t = t.apply(o, s)).next());
});
import { selfAxios as p } from "@oppein/op-utils";
function c(o) {
  return l(this, null, function* () {
    return (yield p.post(
      "/bsplatform/form/ruleValidate",
      o
    )).data;
  });
}
export {
  c as postRuleValidate
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/commoditycenter/form/ruleValidate/post.js
// module id = 173
// module chunks = 41